import { Spin } from 'antd';
import { Navigate, Outlet } from 'react-router-dom';

import { routes } from '@/config/routes';
import { useAuth } from '@/providers/auth-provider';

export function RequireAuth() {
  const { status } = useAuth();

  if (status === 'unknown') {
    return (
      <div style={{ display: 'grid', placeItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }
  if (status === 'unauthenticated') {
    // Deliberately no `?next=`: logging back in after an expiry must land on the dashboard, not
    // on whatever screen the dead session was last showing (ADO 113437). The return-to-deep-link
    // behaviour this replaces was unreachable in practice anyway — nothing consumed the
    // interceptor's `UnauthorizedError`, so an expiry only surfaced on a reload, which loses the
    // route regardless.
    return <Navigate to={routes.login} replace />;
  }
  return <Outlet />;
}
